import { CHIRP_TOOL_MAP } from '../../constants/Tools';
export const getChirpTool = toolName => {
  const tool = CHIRP_TOOL_MAP[toolName];
  if (!tool) {
    throw new Error(`Tool ${toolName} not found`);
  }
  return tool;
};
export const getChirpToolOrLegacyTool = (toolName, isUngatedForLoadableTools) => {
  if (isUngatedForLoadableTools) {
    return getChirpTool(toolName);
  }
  return {
    name: toolName
  };
};